import Vue from 'vue'

export default function authCheck (to, next) {
  if (to.matched.some(record => record.meta.isAdmin)) {
    if (Vue.auth.user.role.name === 'Admin') {
      next()
    } else {
      next({ name: 'login' })
    }
  } else if (to.matched.some(record => record.meta.isGuest)) {
    if (Vue.auth.isAuthenticated()) {
      next({ name: 'dashboard' })
    } else {
      next()
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/authCheck.js